<script setup lang="ts" generic="T extends keyof GA4Events">
import { GA4Events } from "nuxt-ga4"

const props =
  defineProps<{
    promotion?: any
    promoId: string
  }>()

const { promoId } = toRefs(props)

const componentEvent = ref<any>()

/**
 * @description Define select_promotion payload event
 */
const GASelectPromotionPayload = computed<Omit<GA4Events[T], "event">>(() => {
  return {
    event: "select_promotion",
    action: "select_promotion",
    ecommerce: {
      currency: "EUR",
      items: props.promotion
    }
  }
})
/**
 * @description Send event manualy
 */
const sendGA4EventPromotion = () => {
  componentEvent.value?.sendEvent({ clearEcommerce: false })
}
</script>

<template>
  <div @click.native.capture="sendGA4EventPromotion">
    <GAEvent
      event="custom_event"
      :eventKey="`select_promotion_${promoId}`"
      :payload="GASelectPromotionPayload"
      :lazy="true"
      ref="componentEvent"
    >
      <slot />
    </GAEvent>
  </div>
</template>
